var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateByIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Created By") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12.0_Creatives_59",
    transform: "translate(-249.000000, -390.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-+-Rectangle-+-Rectangle-Copy-10-+-Rectangle-Copy-11-+-Rectangle-Copy-12-+-Checked-in-Station-+-Station-1-+-Station-1-Copy-+-Station-1-Copy-2-+-Station-1-Copy-3-+-View-all-+-View-all-Copy-+-View-all-Copy-2-+-View-all-Copy-3-+-Chip-Copy-2-+-Chip-Copy-5-+-Chip-Copy-6-+-Chip-Copy-7-+-Rectangle-Copy-13-+-Station-1-Copy-4-+-View-all-Copy-4-+-Chip-Copy-8-+-Rectangle-Copy-14-+-Station-1-Copy-5-+-View-all-Copy-5-+-Chip-Copy-9-+-Rectangle-Copy-15-+-Station-1-Copy-6-+-View-all-Copy-6-+-Chip-Copy-10-Mask",
    transform: "translate(80.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Solid-/-Ad-Video-Copy",
    transform: "translate(165.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,12 C14.21,12 16,10.21 16,8 C16,5.79 14.21,4 12,4 C9.79,4 8,5.79 8,8 C8,10.21 9.79,12 12,12 Z M12,14 C9.33,14 4,15.34 4,18 L4,20 L20,20 L20,18 C20,15.34 14.67,14 12,14 Z",
    id: "Shape",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateByIcon);
export default __webpack_public_path__ + "static/media/CreateByIcon.41df48beeea4676e3be66801ef5c94a5.svg";
export { ForwardRef as ReactComponent };